import { render, staticRenderFns } from "./PopUpAttribution.vue?vue&type=template&id=b046c850&scoped=true"
import script from "./PopUpAttribution.vue?vue&type=script&lang=js"
export * from "./PopUpAttribution.vue?vue&type=script&lang=js"
import style0 from "./PopUpAttribution.vue?vue&type=style&index=0&id=b046c850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b046c850",
  null
  
)

export default component.exports